import React from 'react';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';
import Input from '@mui/material/TextField';

import TranslationIds from '../../../commons/translationIds';

function renderZip (p) {
    const {
        fields,
        fieldErrors,
        setSubscribersFields,
        classes,
        translate,
        subscribersFields,
        touched,
    } = p;

    if (!fields || !fields.zip) {
        return (<React.Fragment></React.Fragment>);
    }
    
    function getLabel () {
        if (fields.zip === 1) {
            return `${translate(TranslationIds.REGISTRATION_LABEL_ZIP)}*`;
        }

        return translate(TranslationIds.REGISTRATION_LABEL_ZIP);   
    }

    function getHelperText () {
        if (touched.zip && fieldErrors.zip) {
            return translate(TranslationIds.REGISTRATION_REQUIRED_ZIP);
        }
       return '';
    }

    function inputClass () {
        if (fieldErrors.zip) {
            return classes.inputBaseError;
        }
        return classes.inputBase;
    }

    return (
        <Grid className={classNames(['ecal-reg-field-zip', classes.fieldRoot])}>
            <span className={classNames(['ecal-input-label', classes.fieldLabel])}>
                {getLabel()}
            </span>

            <Input
                id="field_zip"
                name="zip"
                className={inputClass()}
                InputProps={{
                classes: {
                    underline: classes.InputUnderline,
                    input: classes.Input,
                },
                }}
                value={subscribersFields.zip}

                onChange={e => {
                    if (typeof setSubscribersFields === 'function') {
                        setSubscribersFields({
                            zip: e.target.value,
                        }, {
                            selector: '#field_zip',
                            field: 'zip',
                        });
                    }
                }}

                onBlur={(e) => {
                    setSubscribersFields({
                        zip: e.target.value,
                    });
                }}

                margin="normal"
                placeholder={getLabel()}
                type="text"
                fullWidth
                error={ fieldErrors.zip }
                helperText={getHelperText()} 
            />
        </Grid>
    );
}

export default renderZip;
